// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/mehr-als-nur-federn/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const mehrAlsNurFedernDE: PageEntry = {
  id: "post.mehr-als-nur-federn",
  locale: "de",
  slug: "mehr-als-nur-federn",
  seo: {
    title: "„Mehr als nur Federn“ | Dietz GmbH",
    description: "„Mehr als nur Federn“",
  },
  type: "post",
  h1: "„Mehr als nur Federn“",
  blocks: [
    { kind: "heading", level: 2, text: "„Mehr als nur Federn“" },
    { kind: "paragraph", text: "Wir können mehr als nur Federn!" },
    { kind: "paragraph", text: "Neben der Produktion von Federn haben wir uns zusätzlich auf die Herstellung von hybriden Baugruppen spezialisiert. So können wir Herstellungsverfahren, mit denen wir die Lieferkette unserer Kunden optimieren, vorweisen. Unser Portfolio umfasst dabei die Kombination von zwei oder mehreren Fertigungsstufen oder Werkstoffen." },
    { kind: "paragraph", text: "Etliche Experten im Bereich Kunststoff- und Metalltechnik arbeiten Hand in Hand zusammen, um unseren Kunden bestmögliche Prozesslösungen zu bieten. Die Kombination von Kunststoff und Metall vereint hierbei die vorteilhaften Eigenschaften bezüglich Haptik, Akustik und Funktionalität in einem maßgeschneiderten Bauteil." }
  ],
};
